import { z } from 'zod';

import { MESSAGE_DATA_TYPES } from './discriminators';

export const payloadSchema = z.object({
  type: z.literal(MESSAGE_DATA_TYPES.PRIMUM_SUPPORT),
});

export type PrimumSupportMessageData = z.infer<typeof payloadSchema>;

/** Carries no fields of its own — the `type` discriminator is the whole payload. */
export const attributesSchema = z.object({});

export function createPrimumSupportMessageData(): PrimumSupportMessageData {
  return {
    type: MESSAGE_DATA_TYPES.PRIMUM_SUPPORT,
  };
}
